import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import { TRANSLATIONS } from '@app/constants'
import { ctmNumberReadySelector } from '@app/store/ui'

export const Phone = styled.a<{ ready: boolean }>`
  color: ${({ theme }) => theme.global.colors.elemyGreen};
  font-size: 1.5rem;
  line-height: 1.8rem;
  transition: opacity 0.3s;
  opacity: ${({ ready }) => (ready ? 1 : 0)};
`

export const PhoneLink = () => {
  const { genericPhoneNum } = TRANSLATIONS
  const ctmReady = useSelector(ctmNumberReadySelector)

  return (
    <Phone ready={ctmReady} href={`tel: ${genericPhoneNum}`}>
      {genericPhoneNum}
    </Phone>
  )
}
